import React, { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { forgotPassword } from '../core/_requests'
import { StandardResult } from '../../../core/_core'

const initialValues = {
	username: '',
}

const forgotPasswordSchema = Yup.object().shape({
	username: Yup.string()
		// .email('Wrong email format')
		.min(4, 'Minimum 4 characters')
		.max(50, 'Maximum 50 symbols')
		.required('Email is required'),
})

export function ForgotPassword() {
	const [loading, setLoading] = useState<boolean>(false)
	const [result, setResult] = useState<StandardResult>({
		data: undefined,
		success: undefined,
		message: undefined
	})
	const formik = useFormik({
		initialValues,
		validationSchema: forgotPasswordSchema,
		onSubmit: (values) => {
			setLoading(true)
			setResult({ ...result, success: undefined })
			setTimeout(() => {
				forgotPassword(values.username)
					.then((result) => {
						var r = result.data as StandardResult
						setResult(r)
						setLoading(false)
					})
					.catch((e) => {
						setResult({
							success: false,
							data: null,
							message: "Failed to request Forgot Password!"
						})
						setLoading(false)
					})
			}, 1000)
		},
	})

	return (
		<>
			<form
				className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
				noValidate
				id='kt_login_password_reset_form'
				onSubmit={formik.handleSubmit}>
				<div className='text-center mb-10'>
					<h2 className='text-dark mb-3'>Forgot Password ?</h2>
					<div className='text-gray-400 fw-bold fs-4'>Enter your email to reset your password.</div>
				</div>

				{!result.success && result.success !== undefined && (
					<div className='mb-lg-5 alert alert-danger rounded-0'>
						<div className='alert-text fw-bold'>
							{result.message}
						</div>
					</div>
				)}

				{result.success && result.success !== undefined && result.message && (
					<div className='mb-lg-5 alert alert-success rounded-0'>
						<div className='text-success fw-bold'>{result.message}</div>
					</div>
				)}

				<div className='fv-row mb-10'>
					<label className='form-label fw-bold text-gray-900 fs-6'>Username</label>
					<input
						placeholder='Input Username...'
						autoComplete='off'
						{...formik.getFieldProps('username')}
						className={clsx(
							'form-control form-control-lg form-control-solid',
							{ 'is-invalid': formik.touched.username && formik.errors.username },
							{
								'is-valid': formik.touched.username && !formik.errors.username,
							}
						)}
						onKeyDown={() => setResult({ ...result, success: undefined })}
					/>
					{formik.touched.username && formik.errors.username && (
						<div className='fv-plugins-message-container'>
							<div className='fv-help-block'>
								<span role='alert'>{formik.errors.username}</span>
							</div>
						</div>
					)}
				</div>
				<div className='d-flex flex-wrap justify-content-center pb-lg-0'>
					<button
						type='submit'
						disabled={loading}
						id='kt_password_reset_submit'
						className='btn btn-md btn-primary fw-bolder me-4'>
						{loading ? (
							<span>
								<span className='spinner-border spinner-border-sm align-middle me-2 fs-7'></span>
								Please wait...
							</span>
						) : <span className='indicator-label'>Submit</span>}
					</button>
					<Link to={`${loading ? "" : "/auth/login"}`}>
						<button
							type='button'
							id='kt_login_password_reset_form_cancel_button'
							className='btn btn-lg btn-light-primary fw-bolder'
							disabled={loading || !formik.isValid}
						>
							Cancel
						</button>
					</Link>
				</div>
			</form>
		</>
	)
}
